import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type SelectQuestionAnswerEditorViewModel } from '@/features/jobs/questions/select/SelectQuestionAnswerEditorViewModel'
import { SimpleSelectContainer } from '@/features/jobs/questions/select/components/SimpleSelect/SimpleSelectContainer'
import { AdvancedSelectContainer } from '@/features/jobs/questions/select/components/AdvancedSelect/AdvancedSelectContainer'

export interface SelectQuestionAnswerEditorContainerProps {
  editorVm: SelectQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

/**
 * Long option lists get a searchable dropdown instead of toggles.
 */
export const SelectQuestionAnswerEditorContainer = observer(
  function SelectQuestionAnswerEditorContainer(
    props: SelectQuestionAnswerEditorContainerProps,
  ) {
    return props.editorVm.options.length >= 20 ? (
      <AdvancedSelectContainer {...props} />
    ) : (
      <SimpleSelectContainer {...props} />
    )
  },
)
